module.exports = __webpack_public_path__ + "static/media/image3.429f0301.jpeg";